<template>
    <div>
      <div class="row">
        <div class="col-12">
          <p style="text-align: center; font-size: 10px; min-height: 30px">{{weather.weather[0].description}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12" style="text-align: center; margin-top: 5px; margin-bottom: 5px">
          <i :class="getIcons(weather.weather[0].main, weather.dt)" style="font-size: 46px"></i>
        </div>
      </div>
      <div class="row">
        <div class="col-12" style="text-align: center;">
          <code style="font-size: 20px;">{{Math.round(weather.main.temp)}}°F</code>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p style="font-size: 20px;text-align: center">{{getDate(weather.dt)[0]}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12" style="text-align: center;">
          <code style="font-size: 13px;">{{getHour(weather.dt)}}</code>
        </div>
      </div>
      <div class="row" style="margin-bottom: -11px">
        <div class="col-12" style="text-align: center;">
          <code style="font-size: 15px;">{{getDate(weather.dt)[1] + ' ' + getDate(weather.dt)[2]}}</code>
        </div>
      </div>
    </div>
</template>

<script>
  import { getIcon } from "../../plugins/weatherSettings";
    export default {
      name: "ForecastItem",
      props:['weather', 'timezone'],
      methods:{
        getIcons(con, time){
          return getIcon(con, time*1000)
        },
        getHour(time){
          const data = new Date(time*1000);
          let res = (data.getHours() > 12) ? data.getHours() - 12 : data.getHours();
          res = (res < 10) ? '0' + res : res;
          res = (data.getHours() > 11) ? res + ' PM' : res + ' AM';
          res = (res === '00 AM') ? '12 AM' : res;
          return res;
        },
        getDate(time){
          const data = new Date(time * 1000);
          return data.toDateString().split(' ');
        },
      },
    }
</script>

<style scoped>

</style>
